/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
// import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import objectPath from "object-path";
// import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import axios from "axios";
import { Button, Modal } from "react-bootstrap";
import AppConfig from "../../../../../app/config/AppConfig";
import LoginASPT from "./component/LoginASPT";
import {
  MenuList,
  MenuItem,
  ListItemIcon,
  Typography,
} from "@material-ui/core";
import UserIcon from "@material-ui/icons/Person";
import {myJsonEncrypt, myJsonDecrypt} from "../../../../../app/config/SecurityConfig";

export function UserProfileDropdown() {
  const [showingSetRole, setShowingSetRole] = React.useState(false);
  const [loadingAuth, setloadingAuth] = React.useState(false);
  const [dataRoles, setDataRoles] = React.useState([]);
  const logoutClick = () => {
    window.localStorage.clear();
    window.location.href = "auth/login";
  };
  const showSetRole = () => {

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let parampengguna = JSON.parse(localStorage.getItem("sessiondata")).i_iduser;
    if(sessiondata.id_pengguna_master){
      parampengguna = sessiondata.id_pengguna_master;
    }

    axios.get(AppConfig.GetRole+'/'+parampengguna + session)
      .then(res => {
        setDataRoles(res.data.result.roles);
        setShowingSetRole(true);
    }) 
    .catch(err => {
      alert("not found")
    }) 
  };
  const handleClose = () => {
    setShowingSetRole(false);
  };
  // const uiService = useHtmlClassService();
  // const layoutProps = useMemo(() => {
  //   return {
  //     light:
  //       objectPath.get(uiService.config, "extras.user.dropdown.style") ===
  //       "light",
  //   };
  // }, [uiService]);
  const userdata = JSON.parse(localStorage.getItem("userdata"));
  const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

  const setWithExpiry = (key, value, ttl) => {
    let now = new Date();
    let item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  };

  const setRole = (e, id_role_pengguna) => {
    setloadingAuth(true);
    setShowingSetRole(false);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    const payload = {
          id_role_pengguna: id_role_pengguna,
          id_pengguna: userdata.id_pengguna,
          username: userdata.username,
          token: userdata.token,
          is_edit: userdata.is_edit,
        };

        const formData = new FormData()
              formData.append("data", myJsonEncrypt(JSON.stringify(payload)))

    axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    axios
      .post(AppConfig.SetRole + session, formData)
      .then((res) => {
        let dec = myJsonDecrypt(res.data.result);
        let jresult = JSON.parse(dec);
        if (jresult.status === "success") {
          localStorage.setItem("userdata", JSON.stringify(userdata));
          localStorage.setItem(
            "sessiondata",
            JSON.stringify(jresult.session_data)
          );
          setWithExpiry("statlogin", "true", 7200 * 1000);
          setloadingAuth(false);
          setShowingSetRole(false);
          window.location.reload();
        } else {
          setloadingAuth(false);
          setShowingSetRole(false);
        }
      })
      .catch((err) => {
        setloadingAuth(false);
        setShowingSetRole(false);
      });
  };
  let data_role = [];
  if (dataRoles.length > 0) {
    dataRoles.map((list, i) => {
      data_role.push(
        <MenuItem className="p-5" onClick={(event) => setRole(event, list.id_role_pengguna)}>
          <ListItemIcon>
            <UserIcon />
          </ListItemIcon>
          <Typography variant="inherit">
            {list.nm_peran} ({list.nm_lemb}) - {(list.id_bp === 1) ? "Akademik" : (list.id_bp === 2) ? "Vokasi"  : "Semua"}
          </Typography>
        </MenuItem>
      );
    });
  }
  return (
    <>
    <Dropdown drop="down">
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
        
      >
        <div>
          <div
            className={
              "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
            }
          >
            <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
              Hi,
            </span>{" "}
            <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
              {userdata.nm_pengguna}
            </span>
            <span className="symbol symbol-35 symbol-light-success">
              <span className="symbol-label font-size-h5 font-weight-bold">
                {/* huruf depan samping kanan nama */}
                {/* {userdata.nm_pengguna.slice(0, 2)} */}
                <i className="flaticon-logout text-success" />
              </span>
            </span>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="p-0 m-0 dropdown-menu-top-unround dropdown-menu-xl">
        <>
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/misc/bg-1.jpg"
                )})`,
              }}
            >
              <div className="symbol bg-white-o-15 mr-3">
                <span className="symbol-label text-success font-weight-bold font-size-h4">
                  {userdata.nm_pengguna.slice(0, 2)}
                </span>
                {/*<img alt="Pic" className="hidden" src={user.pic} />*/}
              </div>
              <div className="text-white m-0 flex-grow-1 mr-3 font-size-h7">
                {userdata.username} ({sessiondata.i_namarole})<br/>
                {sessiondata.i_nmunit} - {(sessiondata.i_idbp === 1) ? "Akademik" : (sessiondata.i_idbp === 2) ? "Vokasi"  : "Semua"}
              </div>
            </div>
          {
              (sessiondata.i_isedit === 1) ? 
              <div className="bg-white p-5 float-right rounded">
                <Link to="/edit-profil">
                  <button
                    id="kt_quick_user_toggle"
                    className="btn btn-primary btn-bold mr-5 "
                  >
                    <i className="flaticon-user" />
                    Edit Profil
                  </button>
                </Link>
                <button
                  id="kt_quick_user_toggle"
                  className="btn btn-success btn-bold mr-5 "
                  onClick={showSetRole}
                >
                  <i className="flaticon-lock" />
                  Login As
                </button>
                <button
                id="kt_quick_user_toggle"
                className="btn btn-danger btn-bold "
                onClick={logoutClick}
              >
                <i className="flaticon-logout" />
                Sign Out
              </button> 
            </div> : <div className="bg-white p-5 float-right rounded">
            <button
                  id="kt_quick_user_toggle"
                  className="btn btn-success btn-bold mr-5 "
                  onClick={showSetRole}
                >
                  <i className="flaticon-lock" />
                  Login As
                </button>
                <button
                id="kt_quick_user_toggle"
                className="btn btn-danger btn-bold "
                onClick={logoutClick}
              >
                <i className="flaticon-logout" />
                Sign Out
              </button> 
            </div> 
          }
        </>
      </Dropdown.Menu>
    </Dropdown>
    <Modal size="lg" show={showingSetRole}>
    <Modal.Header closeButton>
      <Modal.Title>Login As</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <MenuList className="m-0 p-0">{data_role}</MenuList>
      <LoginASPT/>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
  <Modal
    size="sm"
    show={loadingAuth}
    backdrop="static"
    keyboard={false}
  >
    <Modal.Body>
      <div className="text-center">
        <span className="spinner spinner-black"></span> <span className="ml-8"> Silahkan ditunggu ... </span>
      </div>
    </Modal.Body>
  </Modal>
  </>
  );
}
